import { loadableReady } from "@loadable/component";
import { hydrate } from "react-dom";
import { HelmetProvider } from "react-helmet-async";

import { loadPolyfillSrcs, POLYFILL_SRCS, isModernBrowser } from "@shared/polyfill";
import { initSentry } from "@shared/utils";
import { OpenCatalogMain } from "@unauthenticated/catalog/index";

initSentry({ enableRouterInstrumentation: true, tracesSampleRate: 0.01 });

const srcs = window[POLYFILL_SRCS];

const loadSPA = () => {
  loadableReady(() => {
    const root = document.querySelector("#root");
    const app = (
      <HelmetProvider>
        <OpenCatalogMain />
      </HelmetProvider>
    );

    hydrate(app, root);
  });
};

if (!isModernBrowser()) {
  loadPolyfillSrcs(srcs, loadSPA);
} else {
  loadSPA();
}
